import { useDispatch } from "react-redux";
import { setLayoutDashboardTitle } from "../../../../store/ui-slice";
import { useContext, useEffect, useRef, useState } from "react";
import { Image } from "primereact/image";
import { Button } from "primereact/button";
import { FaExpand } from "react-icons/fa6";
import { Card } from "primereact/card";
import { Timeline } from "primereact/timeline";
import BarcodeDialog from "../../../../dialogs/BarcodeDialog";
import useAPIRequest from "../../../../custom_hooks/simple/useAPIRequest";
import extractBarcodeData from "../../../../utils/gbb/ExtractBarcodeData";
import UiContext from "../../../../store/ui-context";
import { format } from "date-fns";

const title = "Trace QR Produk";
const qrUrl = `${process.env.REACT_APP_MY_URL}/qrcode.png`;

const DetailField = ({ prompt, value }) => {
  return (
    <div className="col-start-start gap-0">
      <span className="text-sm font-semibold text-zinc-400">{prompt}</span>
      <span>{value}</span>
    </div>
  );
};

const TraceBarcodePage = () => {
  const dispatch = useDispatch();
  const uiContext = useContext(UiContext);

  const refBarcodeDialog = useRef(null);
  const [events, setEvents] = useState([]);
  const [headerValue, setHeaderValue] = useState({});
  const [showBarcodeDialog, setShowBarcodeDialog] = useState(false);
  const { requestGet, requestGetOne, requestPost, loading, requestDelete } =
    useAPIRequest();

  useEffect(() => {
    dispatch(setLayoutDashboardTitle({ title }));

    // setEvents([
    //   {
    //     status: "Produksi",
    //     date: "15/10/2020 10:30",
    //     icon: "pi pi-cog",
    //     color: "#9C27B0",
    //   },
    //   {
    //     status: "Langsir",
    //     date: "15/10/2020 14:00",
    //     icon: "pi pi-truck",
    //     color: "#673AB7",
    //   },
    //   {
    //     status: "IN: Gudang AB",
    //     date: "15/10/2020 14:00",
    //     number: "# 151020-AB-IN-00021",
    //     icon: "pi pi-database",
    //     color: "#FF9800",
    //   },
    //   {
    //     status: "OUT: Gudang AB",
    //     date: "19/10/2020 16:15",
    //     number: "# 151020-AB-OUT-00021",
    //     icon: "pi pi-truck",
    //     color: "#673AB7",
    //   },
    //   {
    //     status: "IN: Depot 201",
    //     date: "19/10/2020 14:00",
    //     number: "# 151020-DP-IN-00021",
    //     icon: "pi pi-database",
    //     color: "#FF9800",
    //   },
    //   {
    //     status: "OUT: Mobil Sales",
    //     date: "20/10/2020 16:15",
    //     number: "# 151020-DP-OUT-00021",
    //     icon: "pi pi-truck",
    //     color: "#673AB7",
    //   },
    //   {
    //     status: "Terjual",
    //     date: "20/10/2020 10:00",
    //     number: "# 0000213",
    //     outlet: "(NA) Terang Jaya",
    //     icon: "pi pi-shopping-cart",
    //     color: "#607D8B",
    //   },
    // ]);
  }, []);

  const refineGudangName = (gudangName) => {
    let newGudangName = gudangName
      .toUpperCase()
      .replace("GUDANG", "G.")
      .replace("EXPORT", "EXP")
      .replace("PRODUKSI", "P.");
    return newGudangName;
  };

  const customizedMarker = (item) => {
    const {
      tanggal_transaksi,
      nomor,
      jenis,
      tipe,
      data_gudang_asal,
      data_gudang_tujuan,
    } = item;
    let color = "";
    let icon = "";

    switch (tipe) {
      case "masuk":
        color = "rgb(52 211 153)";
        icon = "pi pi-plus-circle";
        break;
      case "keluar":
        color = "rgb(251 113 133)";
        icon = "pi pi-minus-circle";
        break;
      case "mutasi":
        color = "rgb(249 115 22)";
        icon = "pi pi-truck";
        break;
    }

    return (
      <span
        className="col-center-center rounded-full w-[2rem] h-[2rem] align-items-center justify-content-center text-white border-circle z-1 shadow-1"
        style={{ backgroundColor: color }}
      >
        <i className={icon}></i>
      </span>
    );
  };

  const customizedContent = (item) => {
    const {
      tanggal_transaksi,
      nomor,
      jenis,
      tipe,
      data_gudang_asal,
      data_gudang_tujuan,
      created_at,
    } = item;

    let tanggalTransaksiNew = new Date(tanggal_transaksi);
    let createdAtNew = new Date(created_at);
    tanggalTransaksiNew.setHours(createdAtNew.getHours());
    tanggalTransaksiNew.setMinutes(createdAtNew.getMinutes());
    let tanggalTransaksi = format(tanggalTransaksiNew, "dd/MM/yyyy HH:mm");

    let title = "";
    switch (tipe) {
      case "masuk":
        title = `IN: ${jenis}`;
        break;
      case "keluar":
        title = `OUT: ${jenis}`;
        break;
      case "mutasi":
        title = `LANGSIR: ${jenis}`;
        break;
    }

    let gudangAsal = "";
    let gudangTujuan = "";
    if (data_gudang_asal) {
      gudangAsal = refineGudangName(data_gudang_asal.nama);
    }
    if (data_gudang_tujuan) {
      gudangTujuan = refineGudangName(data_gudang_tujuan.nama);
    }

    return (
      <Card
        title={title}
        subTitle={
          <div className="">
            {nomor}
            {nomor && <br />} {tanggalTransaksi}
            <br />
            <div className="min-h-[0.5rem]" />
            {data_gudang_asal && (
              <span>
                Dari <b>{gudangAsal}</b>
              </span>
            )}{" "}
            {data_gudang_tujuan && (
              <span>
                Ke <b>{gudangTujuan}</b>
              </span>
            )}
          </div>
        }
      ></Card>
    );
  };

  const reloadData = (barcode) => {
    const newHeaderValue = {};
    setHeaderValue({});
    setEvents([]);
    const barcodeData = extractBarcodeData(barcode);

    requestGet({
      fullUrl: `api/transaksi/barcode/track`,
      params: {
        barcode: barcode,
      },
      onSuccess: ({ message, data }) => {
        if (data) {
          const dataDetil = data.detil;
          newHeaderValue.kode = dataDetil.barang.kode;
          newHeaderValue.nama = dataDetil.barang.nama;
          newHeaderValue.supplier = undefined;
          newHeaderValue.kode_produksi = dataDetil.batch;
          newHeaderValue.tanggal_produksi = format(
            barcodeData.tanggal_produksi,
            "dd/MM/yyyy"
          );
          newHeaderValue.jenis_satuan = dataDetil.jenis;
          newHeaderValue.konversi = `${dataDetil.konversi} Unit` ?? "-";
          newHeaderValue.nomor_po = dataDetil.nomor_order;
          newHeaderValue.nomor_unik = dataDetil.unik;
          newHeaderValue.gudang = undefined;
          if (dataDetil.barang.data_jenis_barang) {
            newHeaderValue.kategori = dataDetil.barang.data_jenis_barang.nama;
          } else {
            newHeaderValue.kategori = "-";
          }
          newHeaderValue.berat = `${dataDetil.konversi_induk ?? "-"} Kg`;
        }
        setHeaderValue(newHeaderValue);

        setEvents(data.history);
        setShowBarcodeDialog(false);
      },
      onError: ({ message, data }) => {
        uiContext.showErrorMsg("Error", message);
      },
    });
  };

  const handleShowBarcodeDialog = () => {
    setShowBarcodeDialog(true);
  };

  const handleCloseBarcodeDialog = () => {
    setShowBarcodeDialog(false);
  };

  const handleConfirmBarcodeDialog = (barcode) => {
    reloadData(barcode);
  };

  return (
    <div className="col-start-start p-4 w-full gap-4">
      <BarcodeDialog
        title="Scan Barcode Master"
        ref={refBarcodeDialog}
        visible={showBarcodeDialog}
        onHide={handleCloseBarcodeDialog}
        onSave={handleConfirmBarcodeDialog}
        loading={loading}
      />

      <div className="row-start-start gap-4 w-full h-[21rem]">
        <div className="col-start-start gap-4 min-w-[18.2rem]">
          <div className="elevated-card-tight-vertical row-start-start w-full">
            <Image src={qrUrl} width="250" />
          </div>
          <Button
            className="w-full min-h-[3rem]"
            raised
            onClick={handleShowBarcodeDialog}
          >
            <div className="row-center-center gap-3 w-full">
              <FaExpand /> SCAN QR
            </div>
          </Button>
        </div>
        {/* Detail produk */}
        <div className="elevated-card col-start-start w-full h-full gap-4">
          <DetailField prompt={"Nama Barang"} value={headerValue.nama ?? "-"} />
          <div className="row-start-start gap-16">
            <div className="col-start-start gap-4">
              <DetailField
                prompt={"Kode Barang"}
                value={headerValue.kode ?? "-"}
              />
              <DetailField
                prompt={"Supplier"}
                value={headerValue.supplier ?? "-"}
              />
              <DetailField
                prompt={"Kode Produksi"}
                value={headerValue.kode_produksi ?? "-"}
              />
              <DetailField
                prompt={"Tgl. Produksi"}
                value={headerValue.tanggal_produksi ?? "-"}
              />
            </div>
            <div className="col-start-start gap-4">
              <DetailField
                prompt={"Jenis Satuan"}
                value={headerValue.jenis_satuan ?? "-"}
              />
              <DetailField
                prompt={"Konversi"}
                value={headerValue.konversi ?? "-"}
              />
              <DetailField
                prompt={"No. PO"}
                value={headerValue.nomor_po ?? "-"}
              />
              <DetailField prompt={"Berat"} value={headerValue.berat ?? "-"} />
            </div>
            <div className="col-start-start gap-4">
              <DetailField
                prompt={"No. Unik"}
                value={headerValue.nomor_unik ?? "-"}
              />
              <DetailField
                prompt={"Gudang"}
                value={headerValue.gudang ?? "-"}
              />
              <DetailField
                prompt={"Kategori"}
                value={headerValue.kategori ?? "-"}
              />
            </div>
          </div>
        </div>
      </div>

      {/* Tracing Timeline */}
      <div className="w-full pt-4">
        <Timeline
          value={events}
          align="alternate"
          className="customized-timeline"
          marker={customizedMarker}
          content={customizedContent}
        />
      </div>
      <div />
    </div>
  );
};

export default TraceBarcodePage;
